'use client';

import React, { useState, useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import axios from "axios";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../ui/ToastContext";
import { setGlobal } from "next/dist/trace";
import { API_URL } from "../../config";

declare module "../../config" {
    export const API_URL: string;
}

export function InstitutionCreateForm(): React.JSX.Element {
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [prod, setProd] = useState([]);
    const [userData, setUserData] = useState([]);
    const [tip, setTip] = useState([]);
    const [adress, setAdress] = useState([]);
    const [group, setGroup] = useState([]);
    const [Nume_prenume, setNume_prenume] = useState("");
    const [Nume_adres, setNume_adres] = useState("");
    const [value1, setValue1] = React.useState<Option[] | null>(null);
    const [valuetip, setValuetip] = React.useState<OptionTip[] | null>(null);
    const [valuegroup, setValuegroup] = React.useState<OptionGroup[] | null>(null);
    const [filteredAdress, setFilteredAdress] = React.useState<OptionAdress[] | null>(null);
    const [nameError, setnameError] = useState(false);
    const [logError, setlogError] = useState(false);
    const [pasError, setpasError] = useState(false);
    const [tipError, settipError] = useState(false);
    const [groupError, setgroupError] = useState(false);
    const [isGroupMenuOpen, setIsGroupMenuOpen] = useState(false);
    const [isGroupAdresOpen, setIsGroupAdresOpen] = useState(false);
    const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
    const [idadr, setIDadr] = useState("");
    const getJwtFromCookies = () => {
        const cookies = document.cookie.split("; ");
        const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
        return tokenCookie ? tokenCookie.split("=")[1] : null;
    };
    //const token = getJwtFromCookies();

    const token = localStorage.getItem('jwtToken');


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowGrid(false); // După 1 secundă, comutăm pe grid
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/adress`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setAdress(response.data);

                // Obține ultimul ID
                const lastAddress = response.data[response.data.length - 1];
                const lastAddressId = lastAddress ? lastAddress.adress_id : null;
                //  //////////////////////////console.log("Ultimul ID:", lastAddressId);
                setIDadr(lastAddressId);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/tipinstitution`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setTip(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/grupinstitution`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setGroup(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/cities`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setProd(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/district`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setUserData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    interface Option {
        city_id: number;
        city_name: string;
        district_id: number;
    }

    const organizerOptions: Option[] = prod.map((role: Option) => ({
        city_id: role.city_id,
        city_name: role.city_name,
        district_id: role.district_id
    }));

    interface OptionUser {
        district_id: number;
        district_name: string;
    }

    const organizerOptionsuser: OptionUser[] = userData.map((role: OptionUser) => ({
        district_id: role.district_id,
        district_name: role.district_name,
    }));

    interface OptionTip {
        institute_type_id: number;
        description: string;
    }

    const organizerOptionstip: OptionTip[] = tip.map((role: OptionTip) => ({
        institute_type_id: role.institute_type_id,
        description: role.description,
    }));

    interface OptionGroup {
        institute_group_id: number;
        description: string;
    }

    const organizerOptionsGroup: OptionGroup[] = group.map((role: OptionGroup) => ({
        institute_group_id: role.institute_group_id,
        description: role.description,
    }));

    interface OptionAdress {
        adress_id: number;
        city_id: number;
        description: string;
    }

    const organizerOptionsAdress: OptionAdress[] = adress.map((role: OptionAdress) => ({
        adress_id: role.adress_id,
        city_id: role.city_id,
        description: role.description,
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        //////////////////////////console.log(value1?.[0].city_id)
        if (Nume_prenume === ""
            || !value1 || value1.length === 0
            || !valuetip || valuetip.length === 0
            || !valuegroup || valuegroup.length === 0 || Nume_adres === ""
        ) {
            setnameError(Nume_prenume === "" ? true : false);
            settipError(!valuetip || valuetip?.length === 0 ? true : false);
            setgroupError(!valuegroup || valuegroup?.length === 0 ? true : false);
            setlogError(Nume_adres === "" ? true : false);
            setpasError(!value1 || value1.length === 0 ? true : false);
            //////////////////////////////console.log("Error: Fields are empty or invalid.");
            return;
        }

        const filtered = organizerOptionsAdress.filter((address) =>
            address.description.toLowerCase() === Nume_adres.toLowerCase()
            && address.city_id === value1?.[0].city_id
        );

        try {
            if (valuetip && valuetip.length > 0) {
                for (let tipId of valuetip) {
                    if (valuegroup && valuegroup.length > 0) {
                        for (let groupId of valuegroup) {
                            //////////////////////////////console.log(producerId1.district_id);
                            //////////////////////////////console.log(producerId.city_id);
                            await axios.post(`${API_URL}/api/institutions`, {
                                description: Nume_prenume, institute_type_id: tipId.institute_type_id, institute_group_id: groupId.institute_group_id
                            });
                        }
                    }
                }
            }



            if (filtered?.length === 1) {
                const response = await axios.get(`${API_URL}/api/institutions`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                const institutionId = response.data.find((i) => i.description === Nume_prenume).institution_id;
                await axios.post(`${API_URL}/api/adressinstitutions`, {
                    institution_id: institutionId,
                    adress_id: filtered[0].adress_id
                });
            }
            else {
                if (value1 && value1.length > 0) {
                    for (let cityId of value1) {
                        //////////////////////////////console.log(producerId1.district_id);
                        //////////////////////////////console.log(producerId.city_id);
                        await axios.post(`${API_URL}/api/adress`, {
                            description: Nume_adres,
                            city_id: cityId.city_id
                        });
                    }
                }

                const response = await axios.get(`${API_URL}/api/institutions`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                const institutionId = response.data.find((i) => i.description === Nume_prenume).institution_id;

                await axios.post(`${API_URL}/api/adressinstitutions`, {
                    institution_id: institutionId,
                    adress_id: idadr + 1
                });
            }

            handleClose();
            showToast({
                message: "Datele au fost salvate cu succes!",
                type: "success",
                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
            });
        } catch (error) {
            console.error(error);
            showToast({
                message: "Eroare la inserarea datelor!",
                type: "error",
                icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
            });
        }
    };

    const handleClose = () => {
        navigate(-1); // Use navigate to go back
    };

    const handleChange = (e) => {
        setNume_prenume(e.target.value);
    };

    const handleChangea = (e) => {
        const value = e.target.value;
        setNume_adres(value);
        //         //////////////////////////console.log('value', value1)
        // //////////////////////////console.log(organizerOptionsAdress)
        if (value) {
            // Filter addresses based on user input
            const filtered = organizerOptionsAdress.filter((address) =>
                address.description.toLowerCase().includes(value.toLowerCase())
                && address.city_id === value1?.[0].city_id
            );
            setIsGroupAdresOpen(true);
            setFilteredAdress(filtered);
        } else {
            setFilteredAdress([]);
            setIsGroupAdresOpen(false);
        }

        // Handle error for empty input
        if (!value) {
            setnameError(true);
        } else {
            setnameError(false);
        }
    };

    const handleSelectAddress = (address) => {
        setNume_adres(address.description);
        setIsGroupAdresOpen(false);

        setFilteredAdress([]); // Close the suggestions once an address is selected
    };

    const isDarkMode = document.documentElement.classList.contains('dark');

    useEffect(() => {
       ////console.log(isDarkMode)
    }, []);
    return (
        <div >
            {showGrid ? (
                <div className="flex flex-row gap-2">
                    <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
                    <div className="flex flex-col gap-2">
                        <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
                    </div>
                </div>
            ) : (
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                    }}
                >
                    <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                        <CardHeader subheader="Informatia poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }} />
                        <Divider className="dark:bg-gray-400" />
                        <CardContent>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Denumirea institutie
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${nameError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="firstName"
                                        placeholder="Denumirea"
                                        value={Nume_prenume}
                                        onChange={handleChange}
                                    />
                                    {nameError && <p className="text-red-500 text-sm">Denumirea este obligatorie.</p>}

                                </div>

                                <div className="relative">
                                    {isGroupAdresOpen || (
                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10">
                                            Oras / sat
                                        </label>
                                    )}
                                    <Select
                                        options={organizerOptions}
                                        placeholder="Select oras/sat..."
                                        classNamePrefix="react-select"
                                        value={value1}
                                        onChange={(selected) => {
                                            //////////////////////////////console.log("Selected value:", selected);
                                            setValue1(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                        }}

                                        getOptionLabel={(e) => {
                                            // Obține district_name corespunzător
                                            const district = organizerOptionsuser.find(i => i.district_id === e.district_id);
                                            const districtName = district ? district.district_name : "N/A";
                                            return `${e.city_name} - ${districtName}`;
                                        }}
                                        getOptionValue={(e) => String(e.city_id)}
                                        menuPortalTarget={document.body}

                                        // styles={{
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         width: '100%',
                                        //         padding: '0.5rem',
                                        //         borderRadius: '0.375rem',
                                        //         borderColor: pasError ? 'red' : '#424242',
                                        //         boxShadow: 'none',
                                        //         height: '3rem',
                                        //         zIndex: 0,
                                        //         color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        //         backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                        //     }),
                                        //     menu: (provided) => ({
                                        //         ...provided,
                                        //         zIndex: 9999,
                                        //         color: isDarkMode ? 'black' : provided.backgroundColor,
                                        //     }),
                                        //     singleValue: provided => ({
                                        //         ...provided,
                                        //         color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        //     })
                                            
                                        // }}
                                        styles={{
                                            control: (provided) => ({
                                              ...provided,
                                              width: '100%',
                                              padding: '0.5rem',
                                              borderRadius: '0.375rem',
                                              borderColor: pasError ? 'red' : '#424242',
                                              boxShadow: 'none',
                                              height: '3rem',
                                              zIndex: 0,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // This affects the input text
                                              backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', // Explicit light mode background
                                            }),
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', // Ensure background matches mode
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Text color for dropdown items
                                            }),
                                            singleValue: (provided) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Selected value color
                                            }),
                                            option: (provided, state) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Individual option text
                                              backgroundColor: state.isSelected 
                                                ? (isDarkMode ? '#374151' : '#E5E7EB')
                                                : (isDarkMode ? '#1f2937' : '#ffffff'),
                                            }),
                                            input: (provided) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Typed input text color
                                            }),
                                          }}
                                    />
                                    {pasError && <p className="text-red-500 text-sm">Orasul/satul este obligatoriu.</p>}
                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                        Grupul de institutii
                                    </label>
                                    <Select
                                        options={organizerOptionsGroup}
                                        placeholder="Select grup..."
                                        classNamePrefix="react-select"
                                        value={valuegroup}
                                        onChange={(selected) => {
                                            //////////////////////////////console.log("Selected value:", selected);
                                            setValuegroup(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                        }}

                                        getOptionLabel={(e) => e.description}
                                        getOptionValue={(e) => String(e.institute_group_id)}
                                        menuPortalTarget={document.body}
                                        onMenuOpen={() => setIsGroupMenuOpen(true)}
                                        onMenuClose={() => setIsGroupMenuOpen(false)}
                                        // styles={{
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         width: '100%',
                                        //         padding: '0.5rem',
                                        //         borderRadius: '0.375rem',
                                        //         borderColor: groupError ? 'red' : '#424242',
                                        //         boxShadow: 'none',
                                        //         height: '3rem',
                                        //         zIndex: 0,
                                        //         color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        //         backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                        //     }),
                                        //     menu: (provided) => ({
                                        //         ...provided,
                                        //         zIndex: 9999,
                                        //         color: isDarkMode ? 'black' : provided.backgroundColor,
                                        //     }),
                                        //     singleValue: provided => ({
                                        //         ...provided,
                                        //         color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        //       })
                                        // }}
                                        styles={{
                                            control: (provided) => ({
                                              ...provided,
                                              width: '100%',
                                              padding: '0.5rem',
                                              borderRadius: '0.375rem',
                                              borderColor: pasError ? 'red' : '#424242',
                                              boxShadow: 'none',
                                              height: '3rem',
                                              zIndex: 0,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // This affects the input text
                                              backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', // Explicit light mode background
                                            }),
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', // Ensure background matches mode
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Text color for dropdown items
                                            }),
                                            singleValue: (provided) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Selected value color
                                            }),
                                            option: (provided, state) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Individual option text
                                              backgroundColor: state.isSelected 
                                                ? (isDarkMode ? '#374151' : '#E5E7EB')
                                                : (isDarkMode ? '#1f2937' : '#ffffff'),
                                            }),
                                            input: (provided) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Typed input text color
                                            }),
                                          }}
                                    />
                                    {groupError && <p className="text-red-500 text-sm">Grupul este obligatoriu.</p>}
                                </div>

                                <div className="relative">
                                    <label className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100 ${!value1 || value1.length === 0 ? 'text-gray-300' : ''}`}>
                                        Adresa
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${logError ? 'border-red-500' : ''} ${!value1 || value1.length === 0 ? 'border-gray-200' : ''}`}
                                        type="text"
                                        name="adresa"
                                        placeholder={!value1 || value1.length === 0 ? "Alegeti initial orasul sau satul" : "Adresa"}
                                        value={Nume_adres}
                                        onChange={handleChangea}
                                        disabled={!value1 || value1.length === 0}
                                    />
                                    {logError && <p className="text-red-500 text-sm">Adresa este obligatorie.</p>}

                                    {/* Display filtered address suggestions */}
                                    {filteredAdress && filteredAdress.length > 0 && (
                                        <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-48 overflow-auto z-10">
                                            {filteredAdress.map((address, index) => (
                                                <div
                                                    key={index}
                                                    className="p-2 cursor-pointer hover:bg-gray-200"
                                                    onClick={() => handleSelectAddress(address)}
                                                >
                                                    {address.description} {/* Afișează descrierea adresei */}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div className="relative">
                                    {isGroupMenuOpen || (
                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10">
                                            Tip de institutie
                                        </label>
                                    )}
                                    <Select
                                        options={organizerOptionstip}
                                        placeholder="Select tipul..."
                                        classNamePrefix="react-select"
                                        value={valuetip}
                                        onChange={(selected) => {
                                            //////////////////////////////console.log("Selected value:", selected);
                                            setValuetip(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                        }}

                                        getOptionLabel={(e) => e.description}
                                        getOptionValue={(e) => String(e.institute_type_id)}
                                        menuPortalTarget={document.body}

                                        // styles={{
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         width: '100%',
                                        //         padding: '0.5rem',
                                        //         borderRadius: '0.375rem',
                                        //         borderColor: tipError ? 'red' : '#424242',
                                        //         boxShadow: 'none',
                                        //         height: '3rem',
                                        //         zIndex: 0,
                                        //         color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        //         backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                        //     }),
                                        //     menu: (provided) => ({
                                        //         ...provided,
                                        //         zIndex: 9999,
                                        //         color: isDarkMode ? 'black' : provided.backgroundColor,
                                        //     }),
                                        //     singleValue: provided => ({
                                        //         ...provided,
                                        //         color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        //       })
                                        // }}
                                        styles={{
                                            control: (provided) => ({
                                              ...provided,
                                              width: '100%',
                                              padding: '0.5rem',
                                              borderRadius: '0.375rem',
                                              borderColor: pasError ? 'red' : '#424242',
                                              boxShadow: 'none',
                                              height: '3rem',
                                              zIndex: 0,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // This affects the input text
                                              backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', // Explicit light mode background
                                            }),
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: 9999,
                                              backgroundColor: isDarkMode ? '#1f2937' : '#ffffff', // Ensure background matches mode
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Text color for dropdown items
                                            }),
                                            singleValue: (provided) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Selected value color
                                            }),
                                            option: (provided, state) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Individual option text
                                              backgroundColor: state.isSelected 
                                                ? (isDarkMode ? '#374151' : '#E5E7EB')
                                                : (isDarkMode ? '#1f2937' : '#ffffff'),
                                            }),
                                            input: (provided) => ({
                                              ...provided,
                                              color: isDarkMode ? '#FFFFFF' : '#1F2937', // Typed input text color
                                            }),
                                          }}
                                    />
                                    {tipError && <p className="text-red-500 text-sm">Tipul este obligatoriu.</p>}

                                </div>
                            </div>
                        </CardContent>
                        <Divider className="dark:bg-gray-400" />
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white" onClick={handleSubmit}>
                                <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="//max-xs:sr-only">Salveaza detaliile</span>

                            </button>
                        </CardActions>
                    </Card>
                </form>
            )}
        </div>
    );
}
